import ReactDOM from 'react-dom/client';
import './index.css';
import Header from './components/Header';
import React, { useEffect } from "react";

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import SearchPrestataires from './pages/SearchPrestataires';
import { Route, BrowserRouter as Router, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import { persistor, store } from './redux/store';
import Home from './pages/Home';
import { LangProvider } from './context/langProvider';
import Subscription from './pages/Subscription';
import AdminDashboard from './pages/AdminDashboard';
import Connexion from './pages/Connexion';
import WebRTCVideoCall from './components/WebRTCVideoCall';
import Profil from './pages/Profil';

// Composant de redirection basé sur la langue du chemin ou du navigateur
const LanguageRedirectHandler = () => {
  const { lang } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isBot = /bot|crawl|slurp|spider|mediapartners/.test(userAgent);

    if (!isBot) {
      const cleanPath = location.pathname.replace(`/${lang}`, '') || '/';
      localStorage.setItem("lang", lang); // Mémoriser la langue
      navigate(cleanPath + location.search, { replace: true });
    }
  }, [lang,location.pathname,location.search,navigate]);

  return null; // rien à afficher, c’est juste une redirection
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
      <LangProvider>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <Routes>
              {/* Routes visibles "nues", la langue est détectée par localStorage ou navigateur */}
              <Route
                path="/"
                element={
                  <div className="container-fluid">
                    <Header />
                    <Home />
                  </div>
                }
              />
              <Route
                path="/search"
                element={
                  <div className="container-fluid">
                    <Header />
                    <SearchPrestataires />
                  </div>
                }
              />
              <Route
                path="/subscription"
                element={
                  <div className="container-fluid">
                    <Header />
                    <Subscription />
                  </div>
                }
              />
              <Route
                path="/adminDashboard"
                element={
                  <div className="container-fluid">
                    <Header />
                    <AdminDashboard />
                  </div>
                }
              />
              <Route
                path="/connexion"
                element={
                  <div className="container-fluid">
                    <Header />
                    <Connexion />
                  </div>
                }
              />
              <Route
                path="/profil"
                element={
                  <div className="container-fluid">
                    <Header />
                    <Profil />
                  </div>
                }
              />
              <Route
              path='/testCallVideo'
              element={
                <div className="container-fluid">
                    <Header />
                    <WebRTCVideoCall/>
                  </div>
              }
              />

              {/* Routes /fr, /en, etc. accessibles aux robots, redirigées chez l'humain */}
              <Route path="/:lang" element={<LanguageRedirectHandler />} />
              <Route path="/:lang/search" element={<LanguageRedirectHandler />} />
              <Route path="/:lang/subscription" element={<LanguageRedirectHandler />} />
              <Route path="/:lang/adminDashboard" element={<LanguageRedirectHandler />} />
              <Route path="/:lang/connexion" element={<LanguageRedirectHandler />} />
              <Route path="/:lang/testCallVideo" element={<LanguageRedirectHandler />} />


            </Routes>
          </Router>
        </PersistGate>
      </LangProvider>
    </Provider>
);
